import fetchServer from "../../fetchServer";

/**
 * PATCH /payment/v1/fee/:id — update fields on the default fee document
 * (e.g. cardFee, bankTransferFee as { method, value }).
 */
export default async function updateDefaultFeeFields(id, fields) {
  let result = {
    return: 0,
    msg: "Something went wrong updating the fee document",
  };

  if (!id) {
    result.msg = "No default fee document id";
    return result;
  }

  try {
    const res = await fetchServer({
      method: "PATCH",
      url: `/payment/v1/fee/${id}`,
      data: fields,
    });

    if (res?.data && !res?.data?.error) {
      result = {
        return: 1,
        msg: "Successful",
        data: res?.data?.data ?? res?.data,
      };
    } else if (res?.data?.error) {
      result.msg = res.data.error;
    } else if (res?.msg) {
      result.msg = res.msg;
    }
  } catch (err) {
    console.log("Network Error!", err);
  }

  return result;
}
